import { Box, CircularProgress } from '@mui/material';
import { createFileRoute, Navigate } from '@tanstack/react-router';
import { useGetUserData } from 'hooks/use-get-user-data';
import type { JSX } from 'react';
import { lazy, Suspense } from 'react';

const StylePlan = lazy(() => import('pages/style-plan'));

const Loader = (): JSX.Element => (
  <Box display="flex" justifyContent="center" alignItems="center" minHeight="50vh">
    <CircularProgress />
  </Box>
);

export const Route = createFileRoute('/_authenticated/_main/style-plan/')({
  component: StylePlanWrapper,
});

function StylePlanWrapper(): JSX.Element {
  const { isSubscriptionExpired } = useGetUserData();

  if (isSubscriptionExpired) {
    return <Navigate to="/renew-subscription" />;
  }

  return (
    <Suspense fallback={<Loader />}>
      <StylePlan />
    </Suspense>
  );
}
